<template>
    <v-app id="vr" class="primary">
        <div id="vrView" v-show="display_type == 1"></div>
        <div id="imageGallery" v-show="display_type == 2">

            <v-toolbar dark color="primary">

                <v-toolbar-title class="white--text">Jit Event</v-toolbar-title>

            </v-toolbar>
            <v-layout>
                <v-flex mt-4 px-2 xs12 sm10 offset-sm1 md8 offset-md2 lg6 offset-lg3>
                    <h2 class="mb-2" v-if="story_name">
                        {{story_name}}
                    </h2>

                    <v-card>
                        <v-container grid-list-sm fluid>
                            <v-layout row wrap>
                                <v-flex
                                        v-for="(imgObject, index) in imgLightBox.imgs"
                                        :key="index"
                                        xs4
                                        d-flex
                                >

                                    <v-card>
                                        <v-img
                                                :src="imgObject.url"
                                                :lazy-src="imgObject.url"
                                                aspect-ratio="1"
                                                height="150px"
                                                class="grey lighten-2"
                                                @click="imgLightBox.index = index"
                                        ></v-img>

                                        <v-card-title primary-title class="pa-2">
                                            <div>
                                                <span class="grey--text">{{imgObject.name}}</span>
                                            </div>
                                        </v-card-title>
                                    </v-card>

                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card>
                </v-flex>
            </v-layout>

            <LightGallery
                    :images="imgLightBox.imgs"
                    :index="imgLightBox.index"
                    :disable-scroll="true"
                    background="rgb(0,0,0)"
                    @close="imgLightBox.index = null"
            ></LightGallery>

            <div class="image_desc" v-if="imgLightBox.visible" v-show="imgLightBox.img_objects[imgLightBox.index].caption">
                {{imgLightBox.img_objects[imgLightBox.index].caption}}
            </div>

<!--            <v-footer-->
<!--                    height="auto"-->
<!--                    color="primary lighten-1"-->
<!--                    fixed-->
<!--            >-->
<!--                <v-layout-->
<!--                        justify-center-->
<!--                        row-->
<!--                        wrap-->
<!--                >-->
<!--                    <v-flex-->
<!--                            primary-->
<!--                            lighten-2-->
<!--                            py-3-->
<!--                            text-xs-center-->
<!--                            white&#45;&#45;text-->
<!--                            xs12-->
<!--                    >-->
<!--                        &copy;2019 — <strong>JitEvent</strong> — {{$t('app.copy_right')}}-->
<!--                    </v-flex>-->
<!--                </v-layout>-->
<!--            </v-footer>-->

        </div>
        <div class="copy-right-wrapper">{{$t('app.copy_right')}}</div>
    </v-app>
</template>

<script>
    import 'aframe';
    import RequestHandler from "~/utils/request-handler";
    import {UrlServices} from "~/utils/url-manager";
    import "~/lib/OptitableVR";
    import MediaType from '~/components/enum/event/MediaType.ts'
    import { LightGallery } from 'vue-light-gallery';

    export default {
        name: "Vr",
        components: {
            LightGallery
        },
        data() {
            return {
                display_type: 0,
                optitable_vr: null,
                story_name: null,
                imgLightBox: {
                    visible: false,
                    index: 0,
                    imgs: [],
                }
            }
        },
        methods: {
            getOptitableVr() {
                if(this.optitable_vr == null){
                    this.optitable_vr = new OptitableVR('vrView', {
                        lang: getApp.$store.state.lang
                    });
                }

                return this.optitable_vr;
            },
            getStoryData(story_id) {
                let me = this;
                RequestHandler.Get(UrlServices.createUrl({name: 'api_public_event_story_get'}), {
                    story_id: story_id,
                    get_vr_data: 1
                }, {
                    'success': function(data){
                        let story_data = data['story_data'];
                        let media_type = data['story_media_type'];
                        me.display_type = parseInt(media_type);
                        me.story_name = story_data.name;
                        if(media_type == MediaType.VR_IMAGE){
                            let optitable_vr = me.getOptitableVr();
                            if(story_data){
                                optitable_vr.setHasVrTour(true);
                                optitable_vr.setVrData(story_data);
                            }
                        } else if(media_type == MediaType.NORMAL_IMAGE) {
                            let story_imgs = [];
                            _.each(story_data.media, function(sm){
                                console.log('sm', sm);
                                story_imgs.push({
                                    url: sm.media.file.absolute_url,
                                    title: sm.media.caption,
                                    name: sm.media.name
                                });
                            });
                            me.imgLightBox.imgs = story_imgs;
                        }


                    },
                    'error': function () {

                    },
                    'complete': function () {

                    }
                });
            },
            getMediaData(media_id) {
                let me = this;
                RequestHandler.Get(UrlServices.createUrl({name: 'api_public_event_media_get'}), {
                    media_id: media_id,
                    get_scene_data: 1
                }, {
                    'success': function(data){
                        let media_data = data['media_data'];
                        let media_type = data['media_type'];
                        me.display_type = parseInt(media_type);
                        if(media_data){

                            if(media_type == MediaType.VR_IMAGE){
                                let optitable_vr = me.getOptitableVr();
                                optitable_vr.setHasVrTour(false);
                                optitable_vr.setVrData({
                                    scenes: [media_data],
                                });

                            }else if(media_type == MediaType.NORMAL_IMAGE) {
                                let story_imgs = [];
                                story_imgs.push({
                                    url: media_data.file.absolute_url,
                                    title: media_data.caption,
                                    name: media_data.name
                                });
                                me.imgLightBox.imgs = story_imgs;
                                $('.light-gallery__close').hide();
                            }

                            //
                            // let file = media_data['file'];
                            // me.url = file['absolute_url'];
                            // me.title = media_data['name'];
                            // me.caption = media_data['caption'];
                        }
                    },
                    'error': function () {

                    },
                    'complete': function () {

                    }
                });
            },
            showImgLightBox(index) {
                    this.imgLightBox.index = index;
                    this.imgLightBox.visible = true;
            },
            hideImgLightBox() {
                this.imgLightBox.visible = false;
            }
        },
        mounted: function() {

            this.url = this.$route.query.url;
            let media_id = this.$route.query.media_id;
            let story_id = this.$route.query.story_id;

            if(media_id){
                this.getMediaData(media_id);
            }else if(story_id){
                this.getStoryData(story_id);
            }
        },
    }

</script>

<style>
    .application--wrap {
        position: fixed;
        height: 100%;
        width: 100%;
        min-height: auto;
    }

    .image_desc {
        position: fixed;
        z-index: 10000;
        bottom: 60px;
        left: 50%;
        background-color: rgba(0,0,0,0.2);
        color: #FFF;
        padding: 8px;
        border-radius: 15px;
        transform: translateX(-50%);
    }

    .light-gallery__text {
        position: fixed!important;
        left: 50%;
        transform: translateX(-50%);
        white-space: initial;
        max-height: 75px;
        max-width: 100%;
        bottom: -5px;
        overflow: auto;
    }

    .copy-right-wrapper {
        position: fixed;
        bottom: 5px;
        left: 5px;
        background-color: rgba(0,0,0,0.5);
        color: #FFF;
        z-index: 9999;
        padding: 0 5px;
        border-radius: 3px;
    }
</style>